// 3-column engine scoreboard: Revenue Leak / Opportunity / Automation
// Readiness. Verbatim from PaidReport.jsx (W2c). All three numbers come
// straight from the 26-field report view-model — no derivation.
export default function ReportScoreboard({
  revenueLeakScore,
  opportunityScore,
  automationReadinessScore,
}) {
  return (
    <div style={{
      display: "grid",
      gridTemplateColumns: "repeat(3, 1fr)",
      gap: 14, marginBottom: 36,
    }} data-testid="paid-report-scoreboard">
      <div className="sf-card-inset">
        <div className="sf-eyebrow" style={{ marginBottom: 6 }}>Revenue Leak</div>
        <div className="sf-score-number" style={{ fontSize: 56 }} data-testid="paid-report-score-leak">{revenueLeakScore}</div>
        <div className="sf-mono sf-muted-text" style={{ marginTop: 4 }}>/ 100</div>
      </div>
      <div className="sf-card-inset">
        <div className="sf-eyebrow" style={{ marginBottom: 6 }}>Opportunity</div>
        <div className="sf-score-number" style={{ fontSize: 56 }} data-testid="paid-report-score-opp">{opportunityScore}</div>
        <div className="sf-mono sf-muted-text" style={{ marginTop: 4 }}>/ 100</div>
      </div>
      <div className="sf-card-inset">
        <div className="sf-eyebrow" style={{ marginBottom: 6 }}>Automation Readiness</div>
        <div className="sf-score-number" style={{ fontSize: 56 }} data-testid="paid-report-score-ar">{automationReadinessScore}</div>
        <div className="sf-mono sf-muted-text" style={{ marginTop: 4 }}>/ 100</div>
      </div>
    </div>
  );
}
